'use strict';

module.exports = require('./websocket');


//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/dist/browser/src/transports/default.js
// module id = Kuz/
// module chunks = 0